import React, { useState } from 'react';
import {Plus, Minus} from 'lucide-react';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {
  items: FAQItem[];
}

export function FAQ({ items }: FAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="space-y-4">
      {items.map((item, index) => (
        <div
          key={index}
          className="bg-white rounded-xl border border-gray-200 overflow-hidden transition-all duration-300 hover:shadow-md"
        >
          <button
            onClick={() => toggleItem(index)}
            className="w-full px-6 py-5 flex items-center justify-between text-left transition-colors hover:bg-gray-50"
          >
            <span className="text-lg font-semibold text-gray-900 pr-8">
              {item.question}
            </span>
            <div className="flex-shrink-0">
              {openIndex === index ? (
                <Minus className="h-5 w-5 text-[#E53E3E] transition-transform duration-300" />
              ) : (
                <Plus className="h-5 w-5 text-gray-400 transition-transform duration-300" />
              )}
            </div>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out ${
              openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            <div className="px-6 pb-5 text-gray-600 leading-relaxed">
              {item.answer}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
